import type Product from '@src/quince-site-common/src/domains/Product'
import { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'
import type Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'
import type { TransparentPricingItem } from '@src/quince-site-common/src/domains/ProductTransparentPricing'
import {
  CUSTOM_FIELD_NAME_TO_FIELD_ID_MAP,
  CUSTOM_FIELD_NAMES,
  isTruthyCustomFieldValue,
} from '@src/quince-site-common/src/helpers/product-custom-fields.constants'

export type TUniqueVariantPricing = Record<number, string>
export type TUniquePricingMap = Record<string, TransparentPricingItem>

export const pidAndSockDonationCostMap = {
  '145': 12.12,
  '532': 4.04,
  '2259': 13.21,
  '1139': 17.04,
  '531': 5.68,
  '318': 17.04,
  '1004': 5.68,
  '1255': 19.32,
  '733': 6.44,
  '1254': 22.32,
  '507': 7.44,
  '546': 17.04,
  '1005': 5.68,
  '2258': 17.04,
  '1192': 17.04,
  '1006': 5.68,
}

const VENDORS_WITHOUT_TRANSPARENT_PRICING = ['FIGB001']
const PRODUCT_IDS_WITHOUT_TRANSPARENT_PRICING = ['7090547916970']
const HIDE_TRANSPARENT_PRICING_CUSTOM_FIELD_ID =
  CUSTOM_FIELD_NAME_TO_FIELD_ID_MAP[CUSTOM_FIELD_NAMES.HIDE_TRANSPARENT_PRICING]

export const shouldHideTransparentPricing = (product: Product | Bundle) => {
  if (PRODUCT_IDS_WITHOUT_TRANSPARENT_PRICING.includes(product.spid.toString())) return true

  if (product.vendorCodes?.some(vendorCode => VENDORS_WITHOUT_TRANSPARENT_PRICING.includes(vendorCode))) return true

  return (
    product.type !== PRODUCT_TYPES.BUNDLE && isTruthyCustomFieldValue(product, HIDE_TRANSPARENT_PRICING_CUSTOM_FIELD_ID)
  )
}
